'use client';

import { RangeColumns } from '@charts';
import { useHeartRate } from '../../hooks/useHeartRate';

export const HeartRate = () => {
  const { samples, resting, domain } = useHeartRate();

  return (
    <RangeColumns
      samples={samples}
      overlay={resting}
      domain={domain}
      height={120}
      ariaLabel="Heart rate, with resting rate overlaid"
      color="var(--color-accent)"
    />
  );
};
